import type { Negocio } from "./tipos";

/**
 * Teléfono normalizado para deduplicar: solo dígitos, con prefijo de país.
 * "+34 612 34 56 78" → "34612345678"; "612345678" → "34612345678"; "0034…" → "34…".
 * Misma regla que la columna generada `telefono_norm` de la base de datos.
 */
export const normalizarTelefono = (telefono?: string | null): string | null => {
  if (!telefono) return null;
  let digitos = telefono.replace(/\D/g, "");
  if (!digitos) return null;
  if (digitos.startsWith("00")) digitos = digitos.slice(2);
  if (digitos.length === 9) digitos = `34${digitos}`;
  return digitos;
};

/** Enlace a Google Maps: por place_id si existe, si no por la dirección. */
export const urlGoogleMaps = (
  negocio: Pick<Negocio, "direccion" | "place_id" | "nombre">,
): string | null => {
  if (negocio.place_id) {
    return `https://www.google.com/maps/place/?q=place_id:${encodeURIComponent(negocio.place_id)}`;
  }
  const consulta = [negocio.nombre, negocio.direccion]
    .filter(Boolean)
    .join(", ");
  if (!negocio.direccion) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(consulta)}`;
};

/** Enlace tel: para el botón de llamar desde el móvil. */
export const enlaceLlamar = (telefono?: string | null): string | null => {
  const n = normalizarTelefono(telefono);
  return n ? `tel:+${n}` : null;
};

/** Web con protocolo (para que el enlace funcione aunque se guarde "bar-pepe.com"). */
export const urlWeb = (web?: string | null): string | null => {
  const w = web?.trim();
  if (!w) return null;
  return /^https?:\/\//i.test(w) ? w : `https://${w}`;
};
